module.exports = __webpack_public_path__ + "static/media/ic_ivcf.d11a36cc.svg";